import { Link } from 'gatsby'
import styled from 'styled-components'
import media from 'styled-media-query'

export const LinkCardTo = styled(Link)`
  text-decoration: none;

  ${media.lessThan('550px')`
        width: 98%;
      `}
`

export const ContainerCardLink = styled.div`
  height: 148px;
  width: 280px;
  padding: 16px;
  border: 1px solid;
  border-color: rgba(22, 22, 22, 0.08);
  border-radius: 8px;
  display: flex;
  box-sizing: content-box;
  background-color: #fefefe;
  gap: 16px;

  ${props =>
    props.hoverEffect &&
    `
     &:hover {
        background-color: #000E40;
        color: #fefefe;
        border-color: none;

        h2,p,svg{
            color: #fefefe;
        }  
    }
  `}

  ${media.lessThan('medium')`
        width: 95%;
        height: 100%;
      `}
`
export const ContentCardLink = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
`
export const IconContentCardLink = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  align-self: center;

  svg {
    height: 24px !important;
    width: 24px !important;
  }
`

export const TitleCardLink = styled.h2`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #000e40;
  font-family: 'Dasa Sans';
`
export const DescriptionCardLink = styled.p`
  font-size: 14px;
  line-height: 24px;
  max-width: 240px;
  font-weight: 400;
  color: #363636;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  font-family: 'Dasa Sans';
`

export const ContentCardLinkWithButton = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 288px;
  gap: 4px;
`

export const DivButtonAndText = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  svg {
    height: 16px !important;
    width: 16px !important;
  }

  p {
    font-size: 14px;
    line-height: 115%;
    max-width: 240px;
    font-weight: bold;
    color: #3d1435;
  }
`

export const ContainerCardLinkWithButton = styled.div`
  height: 148px;
  width: 280px;
  padding: 16px;
  border: 1px solid;
  border-color: rgba(22, 22, 22, 0.08);
  border-radius: 8px;
  display: flex;
  box-sizing: content-box;
  background-color: #fefefe;
  gap: 16px;

  ${props =>
    props.hoverEffect &&
    `
     &:hover {
        background-color: #000E40;
        color: #fefefe;
        border-color: none;

        h2,p,svg{
            color: #fefefe;
        }  
    }
  `}

  ${media.lessThan('medium')`
        width: 98%;
        min-width: 288px;
        height: 100%;
        min-height: 148px;
        max-height: 216px;
      `}

  @media (max-width: 410px) {
    width: 85%;
  }
`
export const LinkCardToCardMobile = styled(Link)`
  text-decoration: none;
  width: 93%;
`
